<template>
  <article
    class="w-blog-post has-post-thumbnail news-card">
    <div class="w-blog-post-h">
      <router-link :to="computedLink" class="news-card__link">
        <div class="w-blog-post-preview">
          <!--3x2-->
          <img :src="card.image_s"
               sizes="(max-width: 520px) 480px, 600px"
               :srcset="`${card.image_xs} 480w, ${card.image_s} 600w`"
               :alt="card.title">
        </div>
      </router-link>
      <div class="w-blog-post-body">
        <h2 class="w-blog-post-title">
          <router-link :to="computedLink" class="entry-title">{{ card.title }}</router-link>
        </h2>
        <div class="w-blog-post-meta hidden">
          <time class="w-blog-post-meta-date"
                :datetime="card.date | formatDate(true)">
            {{ card.date | formatDate }}
          </time>
          <!--<span class="w-blog-post-meta-author">-->
          <!--  <a href="#">Classic</a>-->
          <!--</span>-->
        </div>
        <div class="w-blog-post-content">
          {{ stripHtml(card.text) }}
        </div>
        <router-link :to="computedLink" class="w-blog-post-more w-btn color_light style_outlined">
          <span class="w-btn-label">Продовжити Читати</span>
        </router-link>
      </div>
    </div>
  </article>
</template>

<script>
  import stripHtml from '@/helpers/stripHtml'

  export default {
    name: 'NewsCard',
    props: {
      card: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        stripHtml
      }
    },
    computed: {
      computedLink() {
        return {name: 'news', params: {newsId: this.card.id}}
      }
    }
  }
</script>

<style>

</style>
